import { createContext } from 'react'

const AuthContext = createContext({ authUser: undefined, setAuthUser: user => { } });
export default AuthContext